import { Button, CircularProgress, Container, Grid, TextField, Typography } from "@mui/material";
import { useRef, useState } from "react";
import rrwebPlayer from "rrweb-player";
import { MxUtils } from "../../utils/mxutils";
import { useHistory } from "react-router-dom";
import { DataBases, exportDataBaseToJson, importDataBaseFromJson, retrieveListData, Stores } from "../../store/indexedDB/idb";
import { unpack } from "@rrweb/packer";

export default function Replay() {

    const playerElRef = useRef();
    const containerRef = useRef();
    const history = useHistory();

    if (!MxUtils.getObjectToken().app.includes("964"))
        history.push({
            pathname: '/'
        })

    const [loading, setLoading] = useState(false);
    const [dateTimeInicio, setDateTimeInicio] = useState('');
    const [dateTimeFim, setDateTimeFim] = useState('');
    const [user, setUser] = useState('');

    const rep = async () => {
        try {
            setLoading(true);

            let list = await retrieveListData(DataBases.RrwebDB, Stores.ImagensApp, Date.parse(dateTimeInicio), Date.parse(dateTimeFim));

            let listEvents = [];

            list.forEach(element => {
                let innerList = JSON.parse(element.evento);
                console.log('innerList', innerList);
                listEvents = listEvents.concat(innerList);
            });

            setLoading(false);
            console.log('containerRef', containerRef);
            playerElRef.current = new rrwebPlayer({
                target: playerElRef.current,
                props: {
                    width: containerRef.current.clientWidth,
                    events: listEvents,
                    unpackFn: unpack
                }
            });
        } catch (err) {
            console.error('Replay - Error: ', err);
        }
    }

    const handleSetDateTimeInicio = (e) => {
        setDateTimeInicio(e.target.value);
    }

    const handleSetDateTimeFim = (e) => {
        setDateTimeFim(e.target.value);
    }

    const handleSetUser = (e) => {
        setUser(e.target.value);
    }

    const exportData = async () => {
        let exportedData = await exportDataBaseToJson(DataBases.RrwebDB);

        const blob = new Blob([exportedData], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'data.json'; // Suggested filename for the downloaded file
        document.body.appendChild(a); // Append to body (optional, but ensures it's in the DOM)
        a.click(); // Programmatically click the link to trigger download
        document.body.removeChild(a); // Remove the link after clicking (optional)
        URL.revokeObjectURL(url); // Release the object URL
    }

    const importData = () => {
        let input = document.getElementById('importDataInput');

        input.click();
    }

    const onInputChange = (e) => {
        let file = [];
        Object.assign(file, e.target.files);
        document.getElementById('importDataInput').value = '';

        const reader = new FileReader();

        reader.addEventListener(
            "load",
            async () => {
                console.log(await importDataBaseFromJson(DataBases.RrwebDB, reader.result));
            },
            false,
        );

        reader.readAsText(file[0]);
    }

    return (
        <Container component='main' maxWidth='md'>
            {/* <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/rrweb-player@latest/dist/style.css" /> */}
            <Grid
                container
                item
                ref={containerRef}
                rowSpacing={1}
            >
                {
                    !loading
                        ?
                        <Grid container item ref={playerElRef} />
                        : null
                }
                <Grid
                    container
                    mt={2}
                    xs={12}
                    flexDirection={'row'}
                    item
                    columnSpacing={1}
                    rowSpacing={1}
                >
                    <Grid item xs={6}>
                        <TextField
                            required
                            type='datetime-local'
                            fullWidth
                            label="Data Início"
                            InputLabelProps={{ shrink: true, }}
                            value={dateTimeInicio}
                            onChange={handleSetDateTimeInicio}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            required
                            type='datetime-local'
                            fullWidth
                            label="Data Fim"
                            InputLabelProps={{ shrink: true, }}
                            value={dateTimeFim}
                            onChange={handleSetDateTimeFim}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => { rep(); }}
                            style={{ position: 'relative' }}
                            disabled={loading}
                        >
                            {
                                loading
                                    ? <CircularProgress
                                        sx={{
                                            position: 'absolute'
                                        }}
                                        size={24}
                                        color="error"
                                    />
                                    : null
                            }
                            <Typography>Replay</Typography>
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => { exportData(); }}
                            style={{ position: 'relative' }}
                            disabled={loading}
                        >
                            {
                                loading
                                    ? <CircularProgress
                                        sx={{
                                            position: 'absolute'
                                        }}
                                        size={24}
                                        color="error"
                                    />
                                    : null
                            }
                            <Typography>Export Data</Typography>
                        </Button>
                    </Grid>
                    <input
                        id="importDataInput"
                        onChange={onInputChange}
                        multiple={false}
                        type="file"
                        style={{
                            display: 'none'
                        }}
                    />
                    <Grid item xs={6}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => { importData(); }}
                            style={{ position: 'relative' }}
                            disabled={loading}
                        >
                            {
                                loading
                                    ? <CircularProgress
                                        sx={{
                                            position: 'absolute'
                                        }}
                                        size={24}
                                        color="error"
                                    />
                                    : null
                            }
                            <Typography>Import Data</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}